import atlasAnalysis from '@/assets/image/menus/atlas-analysis.png'
import atlasAnalysis__active from '@/assets/image/menus/atlas-analysis__active.png'
import checkStatus from '@/assets/image/menus/check-status.png'
import checkStatus__active from '@/assets/image/menus/check-status__active.png'
import dataQueries from '@/assets/image/menus/data-queries.png'
import dataQueries__active from '@/assets/image/menus/data-queries__active.png'
import deviceManagement from '@/assets/image/menus/device-management.png'
import deviceManagement__active from '@/assets/image/menus/device-management__active.png'
import diagnosticAnalysis from '@/assets/image/menus/diagnostic-analysis.png'
import diagnosticAnalysis__active from '@/assets/image/menus/diagnostic-analysis__active.png'
import largeScreen from '@/assets/image/menus/large-screen.png'
import largeScreen__active from '@/assets/image/menus/large-screen__active.png'
import onlineMonitor from '@/assets/image/menus/online-monitor.png'
import onlineMonitor__active from '@/assets/image/menus/online-monitor__active.png'
import systemAdministration from '@/assets/image/menus/system-administration.png'
import systemAdministration__active from '@/assets/image/menus/system-administration__active.png'
import pointMeasure from '@/assets/image/menus/point-measure.png'
import pointMeasure__active from '@/assets/image/menus/point-measure__active.png'
import customerManagement from '@/assets/image/menus/customer-management.png'
import customerManagement__active from '@/assets/image/menus/customer-management__active.png'
import inspection from '@/assets/image/menus/inspection.png'
import inspection__active from '@/assets/image/menus/inspection__active.png'
import firmwareUpgrad from '@/assets/image/menus/firmware-upgrad.png'
import firmwareUpgrad__active from '@/assets/image/menus/firmware-upgrad.png__active.png'
import alarmCenter from '@/assets/image/menus/alarm-center.png'
import alarmCenter__active from '@/assets/image/menus/alarm-center__active.png'
import wifi from '@/assets/image/menus/wifi.png'
import wifi__active from '@/assets/image/menus/wifi__active.png'



import Vue from 'vue'
import { SensorNetworkingRouteNames } from '@/router/sensorNetworking'
import { E_RouterNames } from '@/router/types'
import { IMenuItemTop } from '@/view_helper/mainMenu'
import { E_MenuItem } from '@/view_helper/menu'


export {
    /**
     * 报警中心
     */
    alarmCenter,
    alarmCenter__active,

    /**
     * Wifi组网
     */
    wifi,
    wifi__active,

    /**
     * 图谱分析
     */
    atlasAnalysis,
    atlasAnalysis__active,
    /**
     * 健康检测
     */
    checkStatus,
    checkStatus__active,
    /**
     * 数据查询
     */
    dataQueries,
    dataQueries__active,
    /**
     * 设备管理
     */
    deviceManagement,
    deviceManagement__active,
    /**
     * 诊断分析
     */
    diagnosticAnalysis,
    diagnosticAnalysis__active,
    /**
     * 大屏展示
     */
    largeScreen,
    largeScreen__active,
    /**
     * 在线监测
     */
    onlineMonitor,
    onlineMonitor__active,
    /**
     * 系统管理
     */
    systemAdministration,
    systemAdministration__active,
    /**
     * 点测
     */
    pointMeasure,
    pointMeasure__active,
    /**
     * 客户管理
     */
    customerManagement,
    customerManagement__active,
    /**
     * 固件升级
     */
    firmwareUpgrad,
    firmwareUpgrad__active,
}

export function makeMainMenuItems(vm: Vue) {
    const mainMenuItems: IMenuItemTop[] = [
        {
            icon: largeScreen,
            icon_active: largeScreen__active,
            title: E_MenuItem.LargeScreen,
            router: E_RouterNames.largeScreenNormal,
            permission: 'business:large:screen',
        },
        {
            icon: onlineMonitor,
            icon_active: onlineMonitor__active,
            title: E_MenuItem.OnlineMonitor,
            router: E_RouterNames.onlineMonitor,
            permission: 'business:online:monitor',
        },
        {
            icon: diagnosticAnalysis,
            icon_active: diagnosticAnalysis__active,
            title: E_MenuItem.IntelligentDiagnosis,
            permission: 'business:alarm:home',
            children: [
                {
                    title: E_MenuItem.faultAnalysis,
                    router: E_RouterNames.faultAnalysisDefault,
                    permission: 'business:diagnosis:list',
                },
                {
                    title: E_MenuItem.modelAlarmReport,
                    router: E_RouterNames.modelAlarmReport,
                    permission: 'business:diagnosis:model:list',
                }, {
                    title: E_MenuItem.AiAlarmReport,
                    router: E_RouterNames.aiAlarmReport,
                    permission: 'business:alarm:ai',
                }, {
                    title: E_MenuItem.faultRecord,
                    router: E_RouterNames.alarmReport,
                    permission: 'business:alarm:list',
                }, {
                    title: E_MenuItem.FaultCaseLibrary,
                    router: E_RouterNames.FaultCaseLibrary,
                    permission: 'business:data:fault_case_library'
                },]
        },
        {
            icon: checkStatus,
            icon_active: checkStatus__active,
            title: E_MenuItem.healthTesting,
            router: E_RouterNames.healthTesting,
            permission: 'business:health:testing',
        },
        {
            icon: dataQueries,
            icon_active: dataQueries__active,
            title: E_MenuItem.DataQuery,
            permission: 'business:data:home',
            children: [
                {
                    title: E_MenuItem.WeekReport,
                    router: E_RouterNames.weeklyReport,
                    permission: 'business:week',
                },
                {
                    title: E_MenuItem.EquipmentList,
                    router: E_RouterNames.deviceScreen,
                    permission: 'business:equipment:screen:list',
                },
                {
                    title: E_MenuItem.DataRealtime,
                    router: E_RouterNames.realtimeData,
                    permission: 'business:data:current:list',
                }, {
                    title: E_MenuItem.DataHistory,
                    router: E_RouterNames.historyData,
                    permission: 'business:data:history:list',
                }, {
                    title: E_MenuItem.FaultTagLibrary,
                    router: E_RouterNames.faultTagLibrary,
                    permission: 'business:data:history:faultTagLibrary',
                }
            ]
        },
        {
            icon: alarmCenter,
            icon_active: alarmCenter__active,
            title: E_MenuItem.AlarmCenter,
            permission: 'alarmCenter:root',
            children: [
                {
                    title: E_MenuItem.EquipmentAlarm,
                    permission: 'alarmCenter:equipmentAlarm',
                    children: [
                        {
                            title: E_MenuItem.TempVibAlarm,
                            router: E_RouterNames.TempVibAlarm,
                            permission: 'alarmCenter:equipmentAlarm:tempVibAlarm',
                        },
                        {
                            title: E_MenuItem.GasAlarm,
                            router: E_RouterNames.gasAlarm,
                            permission: 'alarmCenter:equipmentAlarm:gasAlarm',
                        },
                        {
                            title: E_MenuItem.GdsAlarm,
                            router: E_RouterNames.gdsAlarm,
                            permission: 'alarmCenter:equipmentAlarm:gdsAlarm',
                        },
                    ]
                },
                {
                    title: E_MenuItem.SensorAlarm,
                    permission: 'alarmCenter:sensorAlarm',
                    children: [

                        {
                            title: E_MenuItem.BatteryAlarm,
                            router: E_RouterNames.BatteryAlarm,
                            permission: 'alarmCenter:sensorAlarm:batteryAlarm',
                        },
                        {
                            title: E_MenuItem.AngleAlarm,
                            router: E_RouterNames.AngleAlarm,
                            permission: 'alarmCenter:sensorAlarm:angleAlarm',
                        },
                        {
                            title: E_MenuItem.OfflineAlarm,
                            router: E_RouterNames.OfflineAlarm,
                            permission: 'alarmCenter:sensorAlarm:offlineAlarm',
                        },
                    ]
                },
                {
                    title: E_MenuItem.PushAlarm,
                    permission: 'alarmCenter:pushAlarm',
                    children: [
                        {
                            title: E_MenuItem.MailPush,
                            router: E_RouterNames.MailPush,
                            permission: 'alarmCenter:pushAlarm:mailPush',
                        },
                        {
                            title: E_MenuItem.WechatPush,
                            router: E_RouterNames.WechatPush,
                            permission: 'alarmCenter:pushAlarm:wechatPush',
                        },
                        {
                            title: E_MenuItem.VoicePush,
                            router: E_RouterNames.VoicePush,
                            permission: 'alarmCenter:pushAlarm:voicePush',
                        },
                    ]
                },
            ]
        },
        {
            icon: atlasAnalysis,
            icon_active: atlasAnalysis__active,
            title: E_MenuItem.WaveSpectrum,
            router: E_RouterNames.waveSpectrum,
            permission: 'business:wave:spectrum',
        },
        {
            icon: pointMeasure,
            icon_active: pointMeasure__active,
            title: E_MenuItem.inspectManagement,
            permission: 'business:inspection',
            children: [
                {
                    title: E_MenuItem.inspectionTask,
                    router: E_RouterNames.inspectionTask,
                    permission: 'business:task:list',
                },               
                {
                    title: E_MenuItem.inspectionDanger,
                    router: E_RouterNames.inspectionDanger,
                    permission: 'business:danger:list',
                },

                {
                    title: E_MenuItem.inspectUpkeep,
                    router: E_RouterNames.inspectionUpkeep,
                    permission: 'business:upkeep:list',
                },
                {
                    title: E_MenuItem.inspectionRepair,
                    router: E_RouterNames.inspectionRepair,
                    permission: 'business:repair:list',
                },
                {
                    title: E_MenuItem.inspectConfig,
                    permission: 'business:inspection:config',
                    children: [
                        {
                            title: E_MenuItem.FactoryImage,
                            router: E_RouterNames.inspectionArea,
                            permission: 'business:inspection:area',
                        },
                        {
                            title: E_MenuItem.inspectionPoint,
                            router: E_RouterNames.inspectionPoint,
                            permission: 'business:point:list',
                        },
                        {
                            title: E_MenuItem.inspectionStandard,
                            router: E_RouterNames.inspectionStandard,
                            permission: 'business:standard:list',
                        },
                        {
                            title: E_MenuItem.inspectionLine,
                            router: E_RouterNames.inspectionLine,
                            permission: 'business:line:list',
                        },
                        {
                            title: E_MenuItem.inspectionTaskPlan,
                            router: E_RouterNames.inspectionTaskPlan,
                            permission: 'business:taskPlan:list',
                        },
                        {
                            title: E_MenuItem.inspectionGroup,
                            router: E_RouterNames.inspectionGroup,
                            permission: 'business:group:list',
                        },
                    ]
                }, {
                    title: E_MenuItem.libManager,
                    permission: 'business:inspect:library',
                    children: [
                        {
                            title: E_MenuItem.inspectionDangerLibrary,
                            router: E_RouterNames.inspectionDangerLib,
                            permission: 'business:danger:lib:list',
                        },
                        {
                            title: E_MenuItem.inspectUpkeepLibrary,
                            router: E_RouterNames.inspectionUpkeepLib,
                            permission: 'business:upkeep:lib:list',
                        },

                        {
                            title: E_MenuItem.inspectionRepairLibrary,
                            router: E_RouterNames.inspectionRepairLib,
                            permission: 'business:repair:lib:list',
                        },
                    ]
                },
                {
                    title: E_MenuItem.inspectWeeklyReport,
                    router: E_RouterNames.inspectWeekReport,
                    permission: 'business:inspection:week:list',
                },
                 {
                    title: E_MenuItem.instantInspection,
                    router: E_RouterNames.instantInspection,
                    permission: 'business:instantInspection:list',
                },
            ]
        },
        {
            icon: wifi,
            icon_active: wifi__active,
            permission: 'business:networking',
            title: E_MenuItem.WifiNetwork,
            children: [
                {
                    title: E_MenuItem.equipmentList,
                    router: SensorNetworkingRouteNames.DeviceList,
                    permission: 'business:networking:list',
                },
                {
                    title: E_MenuItem.equipment,
                    router: SensorNetworkingRouteNames.Eigenvalue,
                    permission: 'business:networking:dataList',
                },
                {
                    title: E_MenuItem.TimeDomainWave,
                    router: SensorNetworkingRouteNames.WaveSpectrum__MultiSpectrum,
                    permission: 'business:networking:wave',
                },
                {
                    title: E_MenuItem.faultRecord,
                    router: SensorNetworkingRouteNames.AlarmReport,
                    permission: 'business:networking:alarm',
                },
            ]
        },
        {
            icon: deviceManagement,
            icon_active: deviceManagement__active,
            title: E_MenuItem.configManager,
            permission: 'business:setting',
            children: [
                {
                    title: E_MenuItem.subcompanyManagement,
                    router: E_RouterNames.subCompanyManagement,
                    permission: 'business:company:list',
                },
                {
                    title: E_MenuItem.DeviceManager,
                    permission: 'business:devicemanager',
                    children: [
                        {
                            title: E_MenuItem.ModelManagement,
                            router: E_RouterNames.modelManagement,
                            permission: 'business:model:list',
                        },
                        {
                            title: E_MenuItem.DeviceManager,
                            router: E_RouterNames.equipmentManagement,
                            permission: 'business:equipment:list',
                        },
                        {
                            title: E_MenuItem.mappingManagement,
                            router: E_RouterNames.sensorManagementNew,
                            permission: 'business:new:sensor:list',
                        },
                        {
                            title: E_MenuItem.bearingManagement,
                            router: E_RouterNames.bearingManagement,
                            permission: 'business:bear:list',
                        },
                    ]
                },
                {
                    title: E_MenuItem.hardwareManagement,
                    permission: 'business:hardwaremanagement',
                    children: [
                        {
                            title: E_MenuItem.gatewayManagement,
                            router: E_RouterNames.gatewayManagement,
                            permission: 'business:gateway:list',
                        },
                        {
                            title: E_MenuItem.sensorManagement,
                            router: E_RouterNames.sensorList,
                            permission: 'business:sensor:list',
                        },
                        {
                            title: E_MenuItem.alarmLamp,
                            router: E_RouterNames.alarmLampManagement,
                            permission: 'business:lamp:list',
                        },
                        {
                            title: E_MenuItem.collectCard,
                            router: E_RouterNames.collectCardManagement,
                            permission: 'business:collectCard:list',
                        },
                        {
                            title: E_MenuItem.gatewaySetting,
                            router: E_RouterNames.gatewaySetting,
                            permission: 'business:gateway:setting',
                        },
                        {
                            title: E_MenuItem.deviceLog,
                            router: E_RouterNames.deviceLog,
                            permission: 'business:deviceLog:list',
                        },
                    ]
                },
                {
                    title: E_MenuItem.thresholdManagement,
                    permission: 'business:thresholdManagement',
                    children: [
                        {
                            title: E_MenuItem.thresholdTemplate,
                            router: E_RouterNames.thresholdManagement,
                            permission: 'business:threshold:list',
                        },
                        {
                            title: E_MenuItem.thresholdSetting,
                            // router: E_RouterNames.sensorThresholdManagement,
                            permission: 'business:thresholdManagement:list',
                            children: [
                                {
                                    title: E_MenuItem.sensorThresholdManagement,
                                    router: E_RouterNames.sensorThresholdManagement,
                                    permission: 'business:thresholdManagement:sensorThresholdManagement'
                                },
                                {
                                    title: E_MenuItem.gasThresholdManagement,
                                    router: E_RouterNames.gasThresholdManagement,
                                    permission: 'business:thresholdManagement:gasThresholdManagement'
                                },
                                {
                                    title: E_MenuItem.gdsThresholdManagement,
                                    router: E_RouterNames.gdsThresholdManagement,
                                    permission: 'business:thresholdManagement:gdsThresholdManagement'
                                },
                            ]
                        },

                        {
                            title: E_MenuItem.equipmentRunThreshold,
                            router: E_RouterNames.equipmentRunThreshold,
                            permission: 'business:equipmentRunThreshold:list'
                        },
                    ]
                },
                {
                    title: E_MenuItem.compensationCoefficient,
                    permission: 'business:temperatureCompensation:list',
                    children: [
                        {
                            title: E_MenuItem.temperatureCompensation,
                            router: E_RouterNames.temperatureCompensation,
                            permission: 'business:temperatureCompensation:list',
                        },
                    ],
                },
            ]
        },
        {
            icon: systemAdministration,
            icon_active: systemAdministration__active,
            title: E_MenuItem.systemManagement,
            permission: 'system:home',
            children: [
                {
                    title: E_MenuItem.userManagement,
                    router: E_RouterNames.userList,
                    permission: 'system:user:list',
                },
                {
                    title: E_MenuItem.permissionManagement,
                    router: E_RouterNames.authorityManagement,
                    permission: 'business:authority:list',
                },
                {
                    title: E_MenuItem.roleManagement,
                    router: E_RouterNames.roleList,
                    permission: 'system:role:list',
                },
                {
                    title: E_MenuItem.emailManagement,
                    router: E_RouterNames.emailManagement,
                    permission: 'business:email:list',
                },
                {
                    title: E_MenuItem.voiceManagement,
                    router: E_RouterNames.voiceManagement,
                    permission: 'business:alarmVoice:list',
                },
                {
                    title: E_MenuItem.customerManagement_log,                    
                    permission: 'system:management:log',
                    isCompanyAdminMenu: true,
                    children: [
                        {
                            title: vm.$t('menu.operatorLog'),
                            router: E_RouterNames.customerManagement_operateLog,
                            permission: 'system:management:log__operationLog',
                            isCompanyAdminMenu: true,
                        },
                        {
                            title: vm.$t('menu.loginLog'),
                            router: E_RouterNames.customerManagement_loginLog,
                            permission: 'system:management:log__loginLog',
                            isCompanyAdminMenu: true,
                        },
                    ]
                },                
                {
                    title: E_MenuItem.aiHelper,
                    router: E_RouterNames.__click,
                    permission: 'system:aiHelper'
                }
            ]
        },
        {
            isSuperAdminMenu: true,
            icon: inspection,
            icon_active: inspection__active,
            id: 'inspection',
            title: vm.$t('menu.inspect'),
            permission: '',
            children: [
                {
                    title: vm.$t('menu.appUpdate'),
                    router: E_RouterNames.appver,
                },
                {
                    title: vm.$t('menu.appArticles'),
                    router: E_RouterNames.appArticles
                }, {
                    title: vm.$t('menu.appBanner'),
                    router: E_RouterNames.appBanner,
                }, {
                    title: vm.$t('inspection.companyIntro'),
                    router: E_RouterNames.appBrief,
                }, {
                    title: vm.$t('menu.appAsk'),
                    router: E_RouterNames.ask,
                },
            ]
        },
        {
            isSuperAdminMenu: true,
            icon: customerManagement,
            icon_active: customerManagement__active,
            id: 'customerManagement',
            title: vm.$t('menu.customerManagement'),
            permission: '',
            children: [
                {
                    title: vm.$t('menu.customerManagement'),
                    router: E_RouterNames.customerManagement_tenant,
                    permission: '',
                },
                {
                    title: vm.$t('menu.menuManagement'),
                    router: E_RouterNames.customerManagement_menu,
                    permission: '',
                },
                {
                    title: vm.$t('system.appMenuSetting'),
                    router: E_RouterNames.customerManagement_appMenu,
                    permission: '',
                },
                {
                    title: vm.$t('system.deepSeekSetting2'),
                    router: E_RouterNames.deepseekSetting,
                },
                {
                    title: vm.$t('system.platformScreenSetting'),
                    router: E_RouterNames.platformScreenSetting,
                },
                {
                    title: vm.$t('menu.systemNotice'),
                    router: E_RouterNames.systemNoticeList,
                },
            ]
        },
        {
            isSuperAdminMenu: true,
            icon: largeScreen,
            icon_active: largeScreen__active,
            router: E_RouterNames.largeScreenAdmin,
            id: 'largeScreenAdmin',
            permission: '',
            title: vm.$t('largeScreen.largeScreen'),
        },
        {
            isSuperAdminMenu: true,
            icon: firmwareUpgrad,
            icon_active: firmwareUpgrad__active,
            id: 'firmwareManagement',
            permission: '',
            title: vm.$t('firmware.firmwareUpgrade'),
            children: [
                {
                    title: vm.$t('sensor.versionUpgrate'),
                    router: E_RouterNames.firmwareUpgrad,
                    permission: '',
                },
            ]
        },
        {
            isSuperAdminMenu: true,
            faIcon: 'book',
            id: 'diagnosticConfig',
            permission: '',
            title: vm.$t('menu.diagnosticConfig'),
            children: [
                {
                    title: vm.$t('menu.diagnosticModel'),
                    router: E_RouterNames.diagnosticModel,
                    permission: '',
                },
                {
                    title: vm.$t('menu.diagnosticResult'),
                    router: E_RouterNames.diagnosticResult,
                    permission: '',
                },
                {
                    title: vm.$t('common.faultCaseLibrary'),
                    router: E_RouterNames.faultCaseLibraryList_root,
                    permission: '',
                },
            ]
        },
        {
            isSuperAdminMenu: true,
            icon: alarmCenter,
            icon_active: alarmCenter__active,
            id: 'adminAlarmCenter',
            title: vm.$t('alarmStatistics.center'),
            router: E_RouterNames.adminAlarmCenter,
            permission: '',
            children: [
                { title: vm.$t('alarmStatistics.monitor'), router: E_RouterNames.adminMonitorAlarm },
                { title: vm.$t('alarmStatistics.sensor'), router: E_RouterNames.adminSensorAlarm },
            ],
        }
    ]
    return mainMenuItems
}
